<template>
  <IonApp class="app-component">

    <ion-page>

    <ion-header :translucent="false">
      <ion-toolbar> 
        <ion-buttons slot="start">
          <ion-menu-button color="primary"></ion-menu-button>
        </ion-buttons> 

        <ion-title>
          <router-link to="/" class="hydrated ion-activatable" style="position: relative; overflow: hiden; padding: 8px;">
            {{ `${storeState.firstName} ${storeState.surName}` }}
            <ion-ripple-effect type="bounded" />
          </router-link>
        </ion-title>

        <ion-buttons slot="end">
          <ion-button>button</ion-button> 
          <router-link to="/">Home</router-link>
        </ion-buttons> 
      </ion-toolbar>
    </ion-header>

    <ion-content :fullscreen="false">
    <IonSplitPane content-id="main-content">
      <ion-menu content-id="main-content" type="overlay" class="app-side-bar">
        <ion-content> 

          <ion-list id="inbox-list">
            <ion-list-header>{{ route.meta.title }}</ion-list-header>
            <ion-note> {{ storeState.email }} </ion-note>
            <ion-menu-toggle auto-hide="false">
              <ion-item router-direction="root" router-link="/" lines="none" detail="false" class="hydrated">
                <ion-icon slot="start"></ion-icon>
                <ion-label>Link</ion-label>
              </ion-item>
            </ion-menu-toggle>
          </ion-list>

        </ion-content>
      </ion-menu>

      <ion-router-outlet id="main-content"></ion-router-outlet>
    </IonSplitPane>

     <!-- fab placed in the center of the content with a list on each side -->
    <ion-fab vertical="bottom" horizontal="end" slot="fixed">
      <ion-fab-button title="share">
        <ion-icon :icon="shareSocialSharp"></ion-icon>
      </ion-fab-button>
      <ion-fab-list side="top">
        <a target="_blank" :href="`http://twitter.com/share?text=I just read this blog post from @DanielSundayEf1, check it out here&url=${getHref()}&hashtags=code,WebDev,javascript,typescript`">
          <ion-fab-button title="Share on twitter">
            <ion-icon :icon="logoTwitter" />
          </ion-fab-button>
        </a>
      </ion-fab-list>
      <ion-fab-list side="start">
        <ion-fab-button title="more" @click="presentShareActionSheet">
          <ion-icon :icon="listSharp" />
        </ion-fab-button>
      </ion-fab-list>
    </ion-fab>

    </ion-content>

    </ion-page>
  </IonApp>
</template>

<script lang="ts">
import { IonApp, IonFab, IonFabList, IonFabButton, IonRippleEffect, IonContent, IonIcon, IonItem, IonButton, IonLabel, IonButtons, IonHeader, IonMenuButton, IonTitle, IonToolbar, IonList, IonListHeader, IonMenu, IonMenuToggle, IonNote, IonPage, IonRouterOutlet, IonSplitPane, actionSheetController } from '@ionic/vue';
import { defineComponent, onMounted, ref } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import { 
  shareSocialSharp,
  logoTwitter,
  closeSharp,
  listSharp
 } from 'ionicons/icons';
import toggleDarkTheme from './composables/toggleDarkTheme';

export default defineComponent({
  name: 'App',
  components: {
    IonPage,
    IonButton,
    IonApp, 
    IonContent, 
    IonIcon, 
    IonItem, 
    IonLabel, 
    IonList, 
    IonListHeader, 
    IonMenu, 
    IonMenuToggle, 
    IonNote, 
    IonRouterOutlet, 
    IonSplitPane,
    IonButtons,
    IonHeader,
    IonMenuButton,
    IonFab,
    IonFabList,
    IonFabButton,
    IonRippleEffect,
    IonTitle,
    IonToolbar
  },
  setup() {

    const presentShareActionSheet = async () => {
      const actionSheet = await actionSheetController
        .create({
          header: 'Share with?',
          buttons: [
            {
              text: 'Favorite',
              handler: () => {
                console.log('Favorite clicked')
              },
            },
            {
              text: 'Cancel',
              role: 'cancel',
              icon: closeSharp,
              handler: () => {
                //
              },
            },
          ],
        });
      return actionSheet.present();
    }
    
    onMounted(() => {

      const runOverAndOver = () => {
        //
        return requestAnimationFrame(runOverAndOver);
      };

      requestAnimationFrame(runOverAndOver);

      // Use matchMedia to check the user preference
      const prefersDark = window.matchMedia('(prefers-color-scheme: dark)');

      toggleDarkTheme(prefersDark.matches);

      // Listen for changes to the prefers-color-scheme media query
      prefersDark.addListener((mediaQuery) => toggleDarkTheme(mediaQuery.matches));

    });

    const getHref = () => window.location.href;

    const selectedIndex = ref(0);
    
    const route = useRoute();
    const store = useStore();
    const storeState = store.state;
    
    return { 
      listSharp,
      logoTwitter,
      shareSocialSharp,
      toggleDarkTheme,
      route,
      storeState,
      getHref,
      selectedIndex,
      presentShareActionSheet
    }
  }
});
</script>

<style scoped>
.app-side-bar{
  --width: 300px !important;
}

a, router-link, .router-link {
  text-decoration: none !important;
}

ion-menu ion-content {
  --background: var(--ion-item-background, var(--ion-background-color, #fff));
}

ion-menu.md ion-content {
  --padding-start: 8px;
  --padding-end: 8px;
  --padding-top: 20px;
  --padding-bottom: 20px;
}

ion-menu.md ion-list {
  padding: 20px 0;
}

ion-menu.md ion-note {
  margin-bottom: 30px;
}

ion-menu.md ion-list-header,
ion-menu.md ion-note {
  padding-left: 10px;
}

ion-menu.md ion-list#inbox-list {
  border-bottom: 1px solid var(--ion-color-step-150, #d7d8da);
}

ion-menu.md ion-list#inbox-list ion-list-header {
  font-size: 22px;
  font-weight: 600;

  min-height: 20px;
}

ion-menu.md ion-list#labels-list ion-list-header {
  font-size: 16px;

  margin-bottom: 18px;

  color: #757575;

  min-height: 26px;
}

ion-menu.md ion-item {
  --padding-start: 10px;
  --padding-end: 10px;
  border-radius: 4px;
}

ion-menu.md ion-item.selected {
  --background: rgba(var(--ion-color-primary-rgb), 0.14);
}

ion-menu.md ion-item.selected ion-icon {
  color: var(--ion-color-primary);
}

ion-menu.md ion-item ion-icon {
  color: #616e7e;
}

ion-menu.md ion-item ion-label {
  font-weight: 500;
}

ion-menu.ios ion-content {
  --padding-bottom: 20px;
}

ion-menu.ios ion-list {
  padding: 20px 0 0 0;
}

ion-menu.ios ion-note {
  line-height: 24px;
  margin-bottom: 20px;
}

ion-menu.ios ion-item {
  --padding-start: 16px;
  --padding-end: 16px;
  --min-height: 50px;
}

ion-menu.ios ion-item.selected ion-icon {
  color: var(--ion-color-primary);
}

ion-menu.ios ion-item ion-icon {
  font-size: 24px;
  color: #73849a;
}

ion-menu.ios ion-list#labels-list ion-list-header {
  margin-bottom: 8px;
}

ion-menu.ios ion-list-header,
ion-menu.ios ion-note {
  padding-left: 16px;
  padding-right: 16px;
}

ion-menu.ios ion-note {
  margin-bottom: 8px;
}

ion-note {
  display: inline-block;
  font-size: 16px;

  color: var(--ion-color-medium-shade);
}

ion-item.selected {
  --color: var(--ion-color-primary);
}
</style>